import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import InfoPageModal from '../../info-page/InfoPageModal';
import ButtonLink from '../../common/ButtonLink';

const PrivacyStatementLink = ({ configStore, children }) => {
  const [show, setShow] = useState(false);

  const toggle = () => {
    setShow(!show);
  };

  return (
    <>
      <ButtonLink className="PrivacyStatementLink" onClick={toggle}>
        {children || (
          <FormattedMessage
            id="privacyStatement.readLinkSentence"
            defaultMessage="Privacy statement here"
          />
        )}
      </ButtonLink>
      {configStore.privacyStatement.infoPageId && show && (
        <InfoPageModal
          isOpen={show}
          toggle={toggle}
          pageId={configStore.privacyStatement.infoPageId}
        />
      )}
    </>
  );
};

PrivacyStatementLink.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
};

export default inject('configStore')(observer(PrivacyStatementLink));
